import { startLearnerNavigation } from './navigation';
import { startPreferenceForms } from './preferences';
startLearnerNavigation();
startPreferenceForms();
